/* Wythout — Read More clamp, shared by the callout, the ingredient label and
   the icon grid. Collapsed state is CSS (wythout-callout.css /
   wythout-ingredient-label.css / wythout-icon-grid.css, each gated on
   <html class="js">, which theme.liquid sets synchronously in the head — so
   there is no unclamped flash); this only opens and closes it.

   One script, two behaviours, picked off data-wy-rm-mode on the section root
   rather than off the BEM prefix — before this merge the callout's and the
   ingredient label's scripts were identical in every executable line:

   - default (callout, ingredient label): no Read More / Read Less text control
     and no collapse. The masked fade at the foot of the clamped body IS the
     button, and expansion is ONE-WAY (client's call, 2026-07-29 on the
     ingredient label, carried to the callout 2026-07-30) — the affordance
     removes itself with the clamp, so focus has to be handed on.
   - "toggle" (icon grid): a real Read More button that collapses again and
     swaps its label each way, and no focus handoff — the control stays put.

   The section root declares its own BEM base in data-wy-rm; the --rm-open /
   --rm-fits state classes the stylesheets key off are derived from it, so this
   file names no section's classes itself. Delegated off document so
   Theme-Editor section reloads need no re-binding, and guarded so several
   read-more sections on one page bind it once. */
(function () {
  if (window.__wyReadMore) return;
  window.__wyReadMore = true;

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function openCls(root) { return root.getAttribute('data-wy-rm') + '--rm-open'; }
  function fitsCls(root) { return root.getAttribute('data-wy-rm') + '--rm-fits'; }

  /* Toggle mode only — the button carries its own text, so it has to say the
     other thing once it has been used. */
  function label(btn, open) {
    var txt = btn.querySelector('[data-wy-rm-label]');
    if (!txt) return;
    var next = open ? btn.getAttribute('data-label-less') : btn.getAttribute('data-label-more');
    if (next) txt.textContent = next;
  }

  /* Release the inline pin once the height transition lands, so the expanded
     body falls back to max-height:none and later reflow can't clip it. */
  function release(body) {
    function done(e) {
      if (e.propertyName !== 'max-height') return;
      body.removeEventListener('transitionend', done);
      body.style.maxHeight = '';
    }
    body.addEventListener('transitionend', done);
  }

  function activate(btn) {
    var root = btn.closest('[data-wy-rm]');
    if (!root) return;
    var body = root.querySelector('[data-wy-rm-body]');
    if (!body) return;

    var OPEN = openCls(root);
    var twoWay = root.getAttribute('data-wy-rm-mode') === 'toggle';
    /* One-way: an already-open body has no control left to click, and re-pinning
       it would clip copy that is meant to stand at its full height. */
    if (!twoWay && root.classList.contains(OPEN)) return;

    var open = twoWay ? btn.getAttribute('aria-expanded') !== 'true' : true;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (twoWay) label(btn, open);

    if (reduced()) {
      body.style.maxHeight = '';
      root.classList.toggle(OPEN, open);
    } else if (open) {
      /* Pin the real content height so the transition runs to the exact target
         instead of a guessed ceiling (which makes short bodies snap open and
         long ones crawl). scrollHeight reports full content height even while
         the element is clamped. */
      body.style.maxHeight = body.scrollHeight + 'px';
      root.classList.add(OPEN);
      release(body);
    } else {
      body.style.maxHeight = body.scrollHeight + 'px';
      void body.offsetHeight; // flush, or dropping to the clamp won't animate
      root.classList.remove(OPEN);
      body.style.maxHeight = '';
    }

    /* One-way only. The fade was the only control and it is gone now, so a
       keyboard user who activated it would be left focused on a display:none
       button — focus would reset to <body> and their reading position with it.
       Hand focus to the body instead. preventScroll: focusing inside a
       clamped/overflow ancestor makes the browser scroll that ancestor to
       bring the focused box into view, jumping the reader's position. */
    if (!twoWay && body.hasAttribute('tabindex')) body.focus({ preventScroll: true });
  }

  /* A body that already fits inside the clamp gets no control and no fade —
     otherwise short copy would sit there with its last lines masked out behind
     a control that reveals nothing. */
  function prune(scope) {
    var roots = (scope || document).querySelectorAll('[data-wy-rm]');
    Array.prototype.forEach.call(roots, function (root) {
      var body = root.querySelector('[data-wy-rm-body]');
      if (!body || root.classList.contains(openCls(root))) return;
      root.classList.toggle(fitsCls(root), body.scrollHeight <= body.clientHeight + 4);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wy-rm-toggle]') : null;
    if (btn) activate(btn);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prune(); });
  } else {
    prune();
  }
  window.addEventListener('load', function () { prune(); });
  document.addEventListener('shopify:section:load', function (e) { prune(e.target); });
})();
